import { FieldProps } from 'formik';
import React from 'react';

type Props = {
  options: Array<any>;
  defaultLabel: string;
  optionRender?: (entity: any) => string;
  valueProperty?: string;
} & Omit<JSX.IntrinsicElements['select'], 'form'> &
  FieldProps;

const Select = ({
  field,
  options,
  defaultLabel,
  optionRender = ({ name, label }) => name || label,
  valueProperty = 'id',
  form,
  ...props
}: Props) => (
  <select {...field} {...props} data-testid={`${field.name}-select`}>
    <option value="" disabled>
      {defaultLabel}
    </option>
    {options.map(option => (
      <option key={option.id} value={option[valueProperty]}>
        {optionRender(option)}
      </option>
    ))}
  </select>
);

export default Select;
